var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 參數設定 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" CYBERBIZ 會員查詢 ")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("CYBERBIZ 會員查詢")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "品牌"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchantOptions,
      "disabled": _vm.isFetchingMerchants
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.isFetchingMerchants ? '載入中...' : '請選擇品牌') + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedMerchantId,
      callback: function callback($$v) {
        _vm.selectedMerchantId = $$v;
      },
      expression: "selectedMerchantId"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('b-form-radio', {
          attrs: {
            "value": "phone"
          },
          on: {
            "change": _vm.handleSearchTypeChange
          },
          model: {
            value: _vm.searchType,
            callback: function callback($$v) {
              _vm.searchType = $$v;
            },
            expression: "searchType"
          }
        }, [_vm._v(" 手機 ")])];
      },
      proxy: true
    }])
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "請輸入手機號碼",
      "disabled": _vm.searchType !== 'phone'
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.phoneQuery,
      callback: function callback($$v) {
        _vm.phoneQuery = $$v;
      },
      expression: "phoneQuery"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('b-form-radio', {
          attrs: {
            "value": "customer_id"
          },
          on: {
            "change": _vm.handleSearchTypeChange
          },
          model: {
            value: _vm.searchType,
            callback: function callback($$v) {
              _vm.searchType = $$v;
            },
            expression: "searchType"
          }
        }, [_vm._v(" 會員ID ")])];
      },
      proxy: true
    }])
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "請輸入會員ID Ex. 12345678",
      "disabled": _vm.searchType !== 'customer_id' || _vm.isCustomerIdFromApi
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.customerIdQuery,
      callback: function callback($$v) {
        _vm.customerIdQuery = $$v;
      },
      expression: "customerIdQuery"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info",
      "disabled": _vm.isLoading || !_vm.canSearch
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v(" 查詢 ")])], 1), _c('editor', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "width": "100%",
      "height": "400px",
      "lang": "json",
      "theme": "chrome",
      "disabled": !_vm.editable
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.result,
      callback: function callback($$v) {
        _vm.result = $$v;
      },
      expression: "result"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }